export default "__VITE_ASSET__b6681f0a__"